export default __webpack_public_path__ + "static/media/yayinlar1.50cdf1ef.png";